import { createTranslations } from '@npco/utils-translations'

export const accountsIncomeAndExpenseTopSectionTranslations =
  createTranslations({
    header: 'Account Activity',
  })
